import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { LearningAreaInterface } from '../+models/LearningArea.interface';

export const LEARNINGAREA_SERVICE_TOKEN = new InjectionToken('LearningAreaService');
export interface LearningAreaServiceInterface {
  getAll(): Observable<LearningAreaInterface[]>;
  getLearningAreas$(
    searchTerm?: string,
    filters?: { [key: string]: string | number[] | number },
    pagination?: { from?: any; amount?: any },
    columns?: string[],
    sorting?: { [key: string]: 'asc' | 'desc' }
  ): Observable<{ results: LearningAreaInterface[]; count: number }>;
  createLearningArea(learningArea: LearningAreaInterface): Observable<LearningAreaInterface>;
  updateLearningArea(learningArea: LearningAreaInterface): Observable<LearningAreaInterface>;
  deleteLearningArea(learningArea: LearningAreaInterface): Observable<boolean>;
}
